const mxModule = require("mxgraph")();

//destructuring
const {
  mxCell,
  mxCellEditor,
  mxCellHighlight,
  mxCellRenderer,
  mxClient,
  mxCodec,
  mxConnectionHandler,
  mxConstants,
  mxConstraintHandler,
  mxDivResizer,
  mxDragSource,
  mxEdgeHandler,
  mxEdgeSegmentHandler,
  mxEdgeStyle,
  mxEllipse,
  mxEvent,
  mxGeometry,
  mxGraph,
  mxGraphHandler,
  mxGraphModel,
  mxGraphView,
  mxGuide,
  mxImage,
  mxPoint,
  mxRubberband,
  mxStyleRegistry,
  mxToolbar,
  mxUtils,
  mxResources,
  mxOutline,
  mxCylinder,
  mxConnectionConstraint,
  mxClipboard,
  mxUndoManager,
  mxKeyHandler,
  mxRectangle,
  mxCellState,
  mxVertexHandler,
} = mxModule;

export {
  mxCell,
  mxCellEditor,
  mxCellHighlight,
  mxCellRenderer,
  mxClient,
  mxCodec,
  mxConnectionHandler,
  mxConstants,
  mxConstraintHandler,
  mxDivResizer,
  mxDragSource,
  mxEdgeHandler,
  mxEdgeSegmentHandler,
  mxEdgeStyle,
  mxEllipse,
  mxEvent,
  mxGeometry,
  mxGraph,
  mxGraphHandler,
  mxGraphModel,
  mxGraphView,
  mxGuide,
  mxImage,
  mxPoint,
  mxRubberband,
  mxStyleRegistry,
  mxToolbar,
  mxUtils,
  mxResources,
  mxOutline,
  mxCylinder,
  mxConnectionConstraint,
  mxClipboard,
  mxUndoManager,
  mxKeyHandler,
  mxRectangle,
  mxCellState,
  mxVertexHandler
};
